<template>
  <div class="sheet-tab">
    <div class="tab-header border-b border-gray-400 mb-2">
      <button
        v-for="(sheet, sheetName) in sheets"
        :key="sheetName"
        @click="() => selectSheet(sheetName)"
        class="p-2 outline-none uppercase font-medium"
        :class="getActiveSheetHeaderClass(sheetName)"
      >
        {{ sheetName }}
      </button>
    </div>
    <div class="tab-content p-2">
      <vue-excel-editor
        v-if="!!selectedSheetData"
        v-model="selectedSheetData"
        ref="exelEditor"
        :readonly="true"
        :no-header-edit="true"
        :page="page"
        :height="tableHeight"
        disable-panel-filter
        disable-panel-setting
        :key="componentKey"
      >
        <vue-excel-column
          v-for="header in columnHeaders"
          :key="header"
          type="string"
          :field="header"
          :label="header"
          :validate="validateColumns"
          readonly
        />
      </vue-excel-editor>
    </div>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
export default {
  props: {
    sheets: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      selectedSheetName: "",
      page: null,
      tableHeight: "auto",
      columnHeaders: [],
      componentKey: 0 // ? for reset vue-excel-editor,
    };
  },
  computed: {
    sheetNames() {
      return Object.keys(this.sheets);
    },
    selectedSheetData() {
      return cloneDeep(this.sheets[this.selectedSheetName]?.data);
    },
    validationCols() {
      return this.sheets[this.selectedSheetName]?.colValidations;
    }
  },
  watch: {
    sheets: {
      immediate: true,
      deep: true,
      handler: function(newSheets) {
        this.validateAllSheets(newSheets);
      }
    },
    selectedSheetData: {
      deep: true,
      immediate: true,
      handler: function() {
        this.setNewTableStyles(this.selectedSheetData);
        this.updateColumnHeaders(this.selectedSheetData);
        setTimeout(() => {
          this.triggerValidateWhenChangeData(this.selectedSheetData);
        }, 300);
      }
    },
    sheetNames: function(newSheetNames) {
      this.activeFirstSheet(newSheetNames);
    }
  },
  methods: {
    setNewTableStyles(tableData) {
      if (tableData && tableData.length >= 17) {
        this.page = 17;
        this.tableHeight = "46vh";
        return;
      }
      this.page = null;
      this.tableHeight = "auto";
    },
    selectSheet(sheetName) {
      this.selectedSheetName = sheetName;
    },
    updateColumnHeaders(selectedSheetData) {
      this.columnHeaders = selectedSheetData
        ? Object.keys(selectedSheetData[0]).filter(colName => colName !== "$id")
        : [];
      this.componentKey++;
    },
    getActiveSheetHeaderClass(sheetName) {
      const isActiveTab = sheetName === this.selectedSheetName;

      return isActiveTab ? "active" : "";
    },
    activeFirstSheet(sheetNames) {
      if (sheetNames && !!sheetNames.length) {
        this.selectedSheetName = sheetNames[0];
      }
    },

    // refer validation: https://www.npmjs.com/package/vue-excel-editor
    validateColumns(content, oldContent, record, field) {
      const colName = field.label;

      if (!this.validationCols) return "";

      const validation = this.validationCols[colName];

      if (!validation) return "";

      const invalidMsg = validation.validate(content);

      return invalidMsg;
    },

    // trigger by re-assign value
    triggerValidateWhenChangeData(newData) {
      const self = this;

      newData.forEach((objData, rowIdx) => {
        Object.entries(objData).forEach(async ([colName, colContent]) => {
          // skip $id column - this is additional column by vue-excel-editor
          if (colName !== "$id") {
            try {
              await self.$refs.exelEditor.updateCell(
                rowIdx,
                colName,
                colContent
              );
            } catch (error) {
              console.error(
                "error triggerValidateWhenChangeData: ",
                rowIdx,
                colName
              );
            }
          }
        });
      });
    },

    validateAllSheets(newSheets) {
      if (!newSheets || newSheets.length === 0) {
        this.$emit("invalid-sheets", false);
        return;
      }

      for (const sheet of Object.values(newSheets)) {
        const { data: records, colValidations } = sheet;

        if (!colValidations) continue;

        for (const [field, validation] of Object.entries(colValidations)) {
          for (const record of records) {
            const invalidMsg = validation.validate(record[field]);

            if (!!invalidMsg) {
              this.$emit("invalid-sheets", true);
              return;
            }
          }
        }
      }

      this.$emit("invalid-sheets", false);
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-header {
  button {
    &:not(.active) {
      @apply text-gray-500;
    }
    &.active {
      @apply text-gray-800;
      @apply border-b border-blue-600;
    }
  }
}
</style>
